module.exports = ".mat-dialog-title {\n    margin: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/mis-negocios/shared/components/validar-sarlaf/validar-sarlaf.component.css
// module id = ./src/app/modules/mis-negocios/shared/components/validar-sarlaf/validar-sarlaf.component.css
// module chunks = main